(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westside-cards-menu"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('westside-menu-slider')) {
  customElements.define('westside-menu-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      const track = this.querySelector('[data-track]');
      const items = [...this.querySelectorAll('[data-item]')];
      const dots = [...this.querySelectorAll('[data-dot]')];
      if (!track || !items.length) return;
      const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
      const go = i => {
        const item = items[Math.max(0, Math.min(items.length - 1, i))];
        const offset = item.offsetLeft - track.offsetLeft - (track.clientWidth - item.clientWidth) / 2;
        track.scrollTo({left: offset, behavior: reduced() ? 'instant' : 'smooth'});
      };
      let active = 0;
      const update = () => {
        const center = track.getBoundingClientRect().left + track.clientWidth / 2;
        let nearest = Infinity;
        items.forEach((item, i) => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < nearest) {nearest = distance; active = i;}
        });
        items.forEach((item,i) => item.classList.toggle('is-active', i === active));
        dots.forEach((dot,i) => {dot.setAttribute('aria-current', String(i === active));});
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      this.querySelector('[data-prev]')?.addEventListener('click', () => go(active - 1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => go(active + 1), options);
      dots.forEach((dot,i) => dot.addEventListener('click', () => go(i), options));
      track.addEventListener('scroll', update, {...options, passive:true});
      track.addEventListener('keydown', e => {
        if (e.target !== track) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); go(active + (e.key === 'ArrowRight' ? 1 : -1));}
      }, options);
      document.addEventListener('shopify:block:select', e => {
        const i = items.findIndex(item => item.dataset.blockId === e.detail.blockId);
        if (i >= 0) go(i);
      }, options);
      this.resize = new ResizeObserver(update); this.resize.observe(track);
      requestAnimationFrame(update);
    }
    disconnectedCallback() {this.abort?.abort(); this.resize?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westside-circle-menu"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('westside-circle-menu')) {
  customElements.define('westside-circle-menu', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const controller = new AbortController();
      const signal = controller.signal;
      const observers = [];
      const frames = new Set();
      this.querySelectorAll('[data-menu-row]').forEach(row => {
        const track = row.querySelector('[data-track]');
        const items = [...row.querySelectorAll('[data-item]')];
        const dots = [...row.querySelectorAll('[data-dot]')];
        const prev = row.querySelector('[data-prev]');
        const next = row.querySelector('[data-next]');
        if (!track || !items.length) return;
        let active = 0;
        let queued = false;
        const goTo = index => {
          const item = items[Math.max(0, Math.min(items.length - 1, index))];
          track.scrollTo({
            left: item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };
        const update = () => {
          queued = false;
          const center = track.scrollLeft + track.clientWidth / 2;
          let distance = Infinity;
          items.forEach((item, i) => {
            const delta = Math.abs(item.offsetLeft + item.offsetWidth / 2 - center);
            if (delta < distance) { distance = delta; active = i; }
          });
          items.forEach((item, i) => item.setAttribute('data-active', String(i === active)));
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
          if (prev) prev.disabled = track.scrollLeft <= 3;
          if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
        };
        const schedule = () => {
          if (queued) return;
          queued = true;
          const frame = requestAnimationFrame(() => { frames.delete(frame); update(); });
          frames.add(frame);
        };
        track.addEventListener('scroll', schedule, { signal, passive: true });
        track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          goTo(active + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        prev?.addEventListener('click', () => goTo(active - 1), { signal });
        next?.addEventListener('click', () => goTo(active + 1), { signal });
        dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i), { signal }));
        document.addEventListener('shopify:block:select', event => {
          const index = items.findIndex(item => item.dataset.blockId === event.detail.blockId);
          if (index >= 0) goTo(index);
        }, { signal });
        const observer = new ResizeObserver(schedule);
        observer.observe(track);
        observers.push(observer);
        schedule();
      });
      this.cleanup = () => {
        controller.abort();
        observers.forEach(observer => observer.disconnect());
        frames.forEach(frame => cancelAnimationFrame(frame));
      };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westside-focus-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('westside-focus-slider')) {
    customElements.define('westside-focus-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.ws-focus__track');
        this.originals = [...this.track.children];
        this.count = this.originals.length;
        if (!this.count) return;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.loop = this.dataset.loop === 'true' && this.count > 1;
        if (this.loop) {
          const cloneSet = () => this.originals.map(slide => {
            const clone = slide.cloneNode(true);
            clone.dataset.clone = 'true';
            clone.removeAttribute('data-shopify-editor-block');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button, [tabindex]').forEach(node => node.tabIndex = -1);
            return clone;
          });
          this.track.prepend(...cloneSet());
          this.track.append(...cloneSet());
        }
        this.slides = [...this.track.children];
        this.index = this.loop ? this.count : 0;
        const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, {...options, signal});
        on(this.track, 'scroll', () => {
          this.paint();
          clearTimeout(this.settle);
          this.settle = setTimeout(() => this.normalize(), 140);
        }, {passive: true});
        on(this.track, 'keydown', e => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); this.step(e.key === 'ArrowRight' ? 1 : -1);
          }
        });
        this.querySelectorAll('[data-direction]').forEach(button => on(button, 'click', () => this.step(Number(button.dataset.direction))));
        on(this.track, 'pointerdown', e => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          this.drag = {x: e.clientX, scroll: this.track.scrollLeft, moved: false};
        });
        on(window, 'pointermove', e => {
          if (!this.drag) return;
          const delta = e.clientX - this.drag.x;
          if (Math.abs(delta) > 6) this.drag.moved = true;
          if (this.drag.moved) { this.track.classList.add('is-dragging'); this.track.scrollLeft = this.drag.scroll - delta; }
        });
        const finish = () => {
          if (!this.drag) return;
          this.suppressClick = this.drag.moved;
          this.drag = null;
          this.track.classList.remove('is-dragging');
          this.go(this.closestIndex(), true);
          setTimeout(() => this.suppressClick = false, 0);
        };
        on(window, 'pointerup', finish); on(window, 'pointercancel', finish);
        on(this.track, 'dragstart', e => e.preventDefault());
        on(this.track, 'click', e => { if (this.suppressClick) { e.preventDefault(); e.stopPropagation(); } }, {capture: true});
        on(this, 'pointerenter', () => this.hovered = true);
        on(this, 'pointerleave', () => this.hovered = false);
        on(this, 'touchstart', () => this.touching = true, {passive: true});
        on(this, 'touchend', () => this.touching = false, {passive: true});
        on(this, 'touchcancel', () => this.touching = false, {passive: true});
        on(this, 'shopify:block:select', e => {
          const i = this.originals.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
          if (i >= 0) this.go(i + (this.loop ? this.count : 0), false);
        });
        this.resize = new ResizeObserver(() => this.go(this.index, false));
        this.resize.observe(this.track);
        this.go(this.index, false);
        if (this.dataset.autoplay === 'true' && this.count > 1) {
          this.timer = setInterval(() => {
            if (!this.reduced.matches && !this.hovered && !this.touching && !this.drag && !document.hidden && !this.contains(document.activeElement) && !window.Shopify?.designMode) this.step(1);
          }, Number(this.dataset.delay) || 4000);
        }
      }
      center(index) {
        const slide = this.slides[index];
        return slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft + slide.offsetWidth / 2 - this.track.clientWidth / 2;
      }
      closestIndex() {
        let winner = 0, distance = Infinity;
        this.slides.forEach((_, i) => { const d = Math.abs(this.center(i) - this.track.scrollLeft); if (d < distance) { distance = d; winner = i; } });
        return winner;
      }
      go(index, smooth) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({left: this.center(this.index), behavior: smooth && !this.reduced.matches ? 'smooth' : 'instant'});
        this.paint();
      }
      step(direction) { this.go(this.closestIndex() + direction, true); }
      paint() {
        this.slides.forEach((slide, i) => {
          const distance = Math.abs(this.center(i) - this.track.scrollLeft) / slide.offsetWidth;
          slide.style.setProperty('--ws-scale', String(1 - Math.min(distance, 1) * .1));
          slide.style.zIndex = String(Math.round(100 - Math.min(distance, 99)));
        });
      }
      normalize() {
        if (this.drag || this.touching) return;
        let i = this.closestIndex();
        if (this.loop && (i < this.count || i >= this.count * 2)) {
          i = this.count + ((i % this.count) + this.count) % this.count;
          this.go(i, false);
        }
        this.index = i;
        const active = this.slides[i].querySelector('h3');
        const status = this.querySelector('[data-status]');
        if (status && this.contains(document.activeElement)) status.textContent = active?.textContent || '';
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.disabled = !this.loop && (Number(button.dataset.direction) < 0 ? i === 0 : i === this.slides.length - 1);
        });
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        this.resize?.disconnect(); clearInterval(this.timer); clearTimeout(this.settle);
        this.querySelectorAll('[data-clone]').forEach(node => node.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westside-glass-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('westside-glass-header')) {
  customElements.define('westside-glass-header', class extends HTMLElement {
    connectedCallback() {
      this.resize = new ResizeObserver(() => { this.parentElement.style.height = this.getBoundingClientRect().height + 'px'; });
      this.resize.observe(this);
      this.classList.add('wg-fixed');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.wg-menu');
      this.syncScroll = () => this.toggleAttribute('data-scrolled', window.scrollY > 24);
      window.addEventListener('scroll', this.syncScroll, { passive: true, signal });
      this.syncScroll();
      this.trigger.addEventListener('click', () => {
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }, { signal });
      this.querySelector('.wg-close').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.focus();
      }, { signal });
      const refreshCart = async () => {
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart.js');
          if (!response.ok) return;
          const cart = await response.json();
          if (this.isConnected) this.querySelector('.wg-count').textContent = cart.item_count;
        } catch {}
      };
      document.addEventListener('cart:update', refreshCart, { signal });
      window.addEventListener('pageshow', refreshCart, { signal });
    }
    disconnectedCallback() {
      if (this.dialog?.open) document.body.style.overflow = this.previousOverflow || '';
      this.resize?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westside-hand-picked"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('westside-hand-picked')) {
    customElements.define('westside-hand-picked', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.ws-hand-picked__track');
        this.originals = [...this.track.children];
        this.count = this.originals.length;
        if (!this.count) return;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.loop = this.dataset.loop === 'true' && this.count > 1;
        if (this.loop) {
          const cloneSet = () => this.originals.map(slide => {
            const clone = slide.cloneNode(true);
            clone.dataset.clone = 'true';
            clone.removeAttribute('data-shopify-editor-block');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button, [tabindex]').forEach(node => node.tabIndex = -1);
            return clone;
          });
          this.track.prepend(...cloneSet());
          this.track.append(...cloneSet());
        }
        this.slides = [...this.track.children];
        this.index = this.loop ? this.count : 0;
        const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, {...options, signal});
        on(this.track, 'scroll', () => {
          this.paint();
          clearTimeout(this.settle);
          this.settle = setTimeout(() => this.normalize(), 140);
        }, {passive: true});
        on(this.track, 'keydown', e => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); this.step(e.key === 'ArrowRight' ? 1 : -1);
          }
        });
        this.querySelectorAll('[data-direction]').forEach(button => on(button, 'click', () => this.step(Number(button.dataset.direction))));
        on(this.track, 'pointerdown', e => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          this.drag = {x: e.clientX, scroll: this.track.scrollLeft, moved: false};
        });
        on(window, 'pointermove', e => {
          if (!this.drag) return;
          const delta = e.clientX - this.drag.x;
          if (Math.abs(delta) > 6) this.drag.moved = true;
          if (this.drag.moved) { this.track.classList.add('is-dragging'); this.track.scrollLeft = this.drag.scroll - delta; }
        });
        const finish = () => {
          if (!this.drag) return;
          this.suppressClick = this.drag.moved;
          this.drag = null;
          this.track.classList.remove('is-dragging');
          this.go(this.closestIndex(), true);
          setTimeout(() => this.suppressClick = false, 0);
        };
        on(window, 'pointerup', finish); on(window, 'pointercancel', finish);
        on(this.track, 'dragstart', e => e.preventDefault());
        on(this.track, 'click', e => { if (this.suppressClick) { e.preventDefault(); e.stopPropagation(); } }, {capture: true});
        on(this, 'pointerenter', () => this.hovered = true);
        on(this, 'pointerleave', () => this.hovered = false);
        on(this, 'touchstart', () => this.touching = true, {passive: true});
        on(this, 'touchend', () => this.touching = false, {passive: true});
        on(this, 'touchcancel', () => this.touching = false, {passive: true});
        on(this, 'shopify:block:select', e => {
          const i = this.originals.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
          if (i >= 0) this.go(i + (this.loop ? this.count : 0), false);
        });
        this.resize = new ResizeObserver(() => this.go(this.index, false));
        this.resize.observe(this.track);
        this.go(this.index, false);
        if (this.dataset.autoplay === 'true' && this.count > 1) {
          this.timer = setInterval(() => {
            if (!this.reduced.matches && !this.hovered && !this.touching && !this.drag && !document.hidden && !this.contains(document.activeElement) && !window.Shopify?.designMode) this.step(1);
          }, Number(this.dataset.delay) || 4000);
        }
      }
      center(index) {
        const slide = this.slides[index];
        return slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft + slide.offsetWidth / 2 - this.track.clientWidth / 2;
      }
      closestIndex() {
        let winner = 0, distance = Infinity;
        this.slides.forEach((_, i) => { const d = Math.abs(this.center(i) - this.track.scrollLeft); if (d < distance) { distance = d; winner = i; } });
        return winner;
      }
      go(index, smooth) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({left: this.center(this.index), behavior: smooth && !this.reduced.matches ? 'smooth' : 'instant'});
        this.paint();
      }
      step(direction) { this.go(this.closestIndex() + direction, true); }
      paint() {
        this.slides.forEach((slide, i) => {
          const distance = Math.abs(this.center(i) - this.track.scrollLeft) / slide.offsetWidth;
          slide.style.setProperty('--ws-scale', String(1 - Math.min(distance, 1) * .1));
          slide.style.zIndex = String(Math.round(100 - Math.min(distance, 99)));
        });
      }
      normalize() {
        if (this.drag || this.touching) return;
        let i = this.closestIndex();
        if (this.loop && (i < this.count || i >= this.count * 2)) {
          i = this.count + ((i % this.count) + this.count) % this.count;
          this.go(i, false);
        }
        this.index = i;
        const active = this.slides[i].querySelector('h3');
        const status = this.querySelector('[data-status]');
        if (status && this.contains(document.activeElement)) status.textContent = active?.textContent || '';
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.disabled = !this.loop && (Number(button.dataset.direction) < 0 ? i === 0 : i === this.slides.length - 1);
        });
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        this.resize?.disconnect(); clearInterval(this.timer); clearTimeout(this.settle);
        this.querySelectorAll('[data-clone]').forEach(node => node.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westside-slider-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('westside-slider-2')) {
    customElements.define('westside-slider-2', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.ws-slider-two__track');
        this.originals = [...this.track.children];
        this.count = this.originals.length;
        if (!this.count) return;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.loop = this.dataset.loop === 'true' && this.count > 1;
        if (this.loop) {
          const cloneSet = () => this.originals.map(slide => {
            const clone = slide.cloneNode(true);
            clone.dataset.clone = 'true';
            clone.removeAttribute('data-shopify-editor-block');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button, [tabindex]').forEach(node => node.tabIndex = -1);
            return clone;
          });
          this.track.prepend(...cloneSet());
          this.track.append(...cloneSet());
        }
        this.slides = [...this.track.children];
        this.index = this.loop ? this.count : 0;
        const on = (target, name, fn, options = {}) => target.addEventListener(name, fn, {...options, signal});
        on(this.track, 'scroll', () => {
          this.paint();
          clearTimeout(this.settle);
          this.settle = setTimeout(() => this.normalize(), 140);
        }, {passive: true});
        on(this.track, 'keydown', e => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); this.step(e.key === 'ArrowRight' ? 1 : -1);
          }
        });
        this.querySelectorAll('[data-direction]').forEach(button => on(button, 'click', () => this.step(Number(button.dataset.direction))));
        on(this.track, 'pointerdown', e => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          this.drag = {x: e.clientX, scroll: this.track.scrollLeft, moved: false};
        });
        on(window, 'pointermove', e => {
          if (!this.drag) return;
          const delta = e.clientX - this.drag.x;
          if (Math.abs(delta) > 6) this.drag.moved = true;
          if (this.drag.moved) { this.track.classList.add('is-dragging'); this.track.scrollLeft = this.drag.scroll - delta; }
        });
        const finish = () => {
          if (!this.drag) return;
          this.suppressClick = this.drag.moved;
          this.drag = null;
          this.track.classList.remove('is-dragging');
          this.go(this.closestIndex(), true);
          setTimeout(() => this.suppressClick = false, 0);
        };
        on(window, 'pointerup', finish); on(window, 'pointercancel', finish);
        on(this.track, 'dragstart', e => e.preventDefault());
        on(this.track, 'click', e => { if (this.suppressClick) { e.preventDefault(); e.stopPropagation(); } }, {capture: true});
        on(this, 'pointerenter', () => this.hovered = true);
        on(this, 'pointerleave', () => this.hovered = false);
        on(this, 'touchstart', () => this.touching = true, {passive: true});
        on(this, 'touchend', () => this.touching = false, {passive: true});
        on(this, 'touchcancel', () => this.touching = false, {passive: true});
        on(this, 'shopify:block:select', e => {
          const i = this.originals.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
          if (i >= 0) this.go(i + (this.loop ? this.count : 0), false);
        });
        this.resize = new ResizeObserver(() => this.go(this.index, false));
        this.resize.observe(this.track);
        this.go(this.index, false);
        if (this.dataset.autoplay === 'true' && this.count > 1) {
          this.timer = setInterval(() => {
            if (!this.reduced.matches && !this.hovered && !this.touching && !this.drag && !document.hidden && !this.contains(document.activeElement) && !window.Shopify?.designMode) this.step(1);
          }, Number(this.dataset.delay) || 4000);
        }
      }
      center(index) {
        const slide = this.slides[index];
        return slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft + slide.offsetWidth / 2 - this.track.clientWidth / 2;
      }
      closestIndex() {
        let winner = 0, distance = Infinity;
        this.slides.forEach((_, i) => { const d = Math.abs(this.center(i) - this.track.scrollLeft); if (d < distance) { distance = d; winner = i; } });
        return winner;
      }
      go(index, smooth) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({left: this.center(this.index), behavior: smooth && !this.reduced.matches ? 'smooth' : 'instant'});
        this.paint();
      }
      step(direction) { this.go(this.closestIndex() + direction, true); }
      paint() {
        this.slides.forEach((slide, i) => {
          const distance = Math.abs(this.center(i) - this.track.scrollLeft) / slide.offsetWidth;
          slide.style.setProperty('--ws-scale', String(1 - Math.min(distance, 1) * .1));
          slide.style.zIndex = String(Math.round(100 - Math.min(distance, 99)));
        });
      }
      normalize() {
        if (this.drag || this.touching) return;
        let i = this.closestIndex();
        if (this.loop && (i < this.count || i >= this.count * 2)) {
          i = this.count + ((i % this.count) + this.count) % this.count;
          this.go(i, false);
        }
        this.index = i;
        const active = this.slides[i].querySelector('h3');
        const status = this.querySelector('[data-status]');
        if (status && this.contains(document.activeElement)) status.textContent = active?.textContent || '';
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.disabled = !this.loop && (Number(button.dataset.direction) < 0 ? i === 0 : i === this.slides.length - 1);
        });
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        this.resize?.disconnect(); clearInterval(this.timer); clearTimeout(this.settle);
        this.querySelectorAll('[data-clone]').forEach(node => node.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ws-welcome-trail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ws-welcome-trail')) {
  customElements.define('ws-welcome-trail', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const controller = new AbortController();
      const opts = { signal: controller.signal };
      const track = this.querySelector('.ws-welcome-track');
      if (!track || !track.children.length) return;
      let frame = 0;
      let last = 0;
      let pausedUntil = 0;
      let hovered = false;
      let focused = false;
      let visible = false;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const originals = [...track.children];
      const clones = [];
      if (this.dataset.autoplay === 'true' && !reduced.matches) {
        originals.forEach(item => {
          const copy = item.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('tabindex', '-1');
          
          track.append(copy);
          clones.push(copy);
        });
      }
      const items = [...track.children];
      let geometry = [];
      let span = 0;
      let position = this.scrollLeft;
      let writtenPosition = this.scrollLeft;
      const paintArc = () => {
        const width = this.clientWidth;
        if (!width) return;
        const radius = width * 2.5;
        geometry.forEach(({ item, center }) => {
          const x = center - this.scrollLeft - width / 2;
          const bounded = Math.max(-width, Math.min(width, x));
          const angle = Math.asin(bounded / radius);
          const y = radius * (1 - Math.cos(angle));
          item.style.setProperty('--trail-y', y.toFixed(3) + 'px');
          item.style.setProperty('--trail-angle', (angle * 180 / Math.PI).toFixed(3) + 'deg');
        });
      };
      const measure = () => {
        geometry = items.map(item => ({ item, center: item.offsetLeft + item.offsetWidth / 2 }));
        span = clones.length ? clones[0].offsetLeft - originals[0].offsetLeft : 0;
        paintArc();
      };
      const resize = new ResizeObserver(measure);
      resize.observe(this);
      measure();
      this.addEventListener('scroll', paintArc, { ...opts, passive: true });
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
      });
      observer.observe(this);
      this.addEventListener('pointerenter', e => {
        if (e.pointerType === 'mouse') hovered = true;
      }, opts);
      this.addEventListener('pointerleave', () => { hovered = false; }, opts);
      this.addEventListener('pointerdown', () => { pausedUntil = performance.now() + 6000; }, opts);
      this.addEventListener('wheel', () => { pausedUntil = performance.now() + 6000; }, { ...opts, passive: true });
      this.addEventListener('focusin', () => { focused = true; }, opts);
      this.addEventListener('focusout', e => { focused = this.contains(e.relatedTarget); }, opts);
      const tick = now => {
        const dt = last ? Math.min(now - last, 48) : 0;
        last = now;
        if (clones.length && visible && !document.hidden && !hovered && !focused && now > pausedUntil && !reduced.matches) {
          if (Math.abs(this.scrollLeft - writtenPosition) > 1) position = this.scrollLeft;
          position += dt * .035;
          if (span > 0 && position >= span) position %= span;
          this.scrollLeft = position;
          writtenPosition = this.scrollLeft;
          paintArc();
        }
        frame = requestAnimationFrame(tick);
      };
      if (clones.length) frame = requestAnimationFrame(tick);
      this.cleanup = () => {
        controller.abort();
        observer.disconnect();
        resize.disconnect();
        cancelAnimationFrame(frame);
        clones.forEach(copy => copy.remove());
      };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
